import React from "react";
import { Chip } from "../Chip";
import moment from "moment";
import { useStore } from "zustand";
import globalStore from "../../../../state";
import { getMessage } from "../../hooks/useWorkspaceAlerts";

export const TrialExpirationChip: React.FC = () => {
    const { usage } = useStore(globalStore, (state) => ({ usage: state.getUsage() }));
    const message = getMessage(usage);

    return (
        <Chip type="text" color="purple">
            <i className="far fa-clock"></i>
            <span className="text-xs">{message}</span>
        </Chip>
    );
};
